import { Link } from "react-router-dom";
import { ArrowUpRight, Camera } from "lucide-react";
import { useProjectPhotos, projectCover } from "../../lib/photos";
import { Reveal, Eyebrow } from "./Reveal";
import { PROJECTS } from "../../data/projects";

const Cover = ({ img }) =>
  img ? (
    <img src={img.src} alt={img.alt} loading="lazy" className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
  ) : (
    <div className="flex aspect-[4/3] w-full items-center justify-center bg-[var(--forest)] text-white/40"><Camera className="h-10 w-10" /></div>
  );

export const FeaturedProjects = () => {
  const { data: uploaded = [] } = useProjectPhotos();
  return (
  <section id="projects" data-testid="featured-projects-section" className="section bg-[var(--paper)] !pb-0">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <Reveal>
        <Eyebrow>Project details for tender reviewers</Eyebrow>
        <h2 className="section-title mt-4">Major projects</h2>
      </Reveal>
      <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {PROJECTS.map((p, i) => (
          <Reveal key={p.slug} delay={(i % 3) * 0.08} className="h-full">
            <Link to={`/projects/${p.slug}`} data-testid={`project-card-${p.slug}`} className="group flex h-full flex-col bg-white">
              <div className="overflow-hidden">
                <Cover img={projectCover(p, uploaded)} />
              </div>
              <div className="flex flex-1 items-start justify-between gap-4 p-6">
                <div>
                  <p className="font-mono text-xs uppercase tracking-wider text-[var(--rust)]">{p.category} · {p.year}</p>
                  <h3 className="mt-2 font-display text-2xl font-bold uppercase leading-tight">{p.short}</h3>
                  <p className="mt-2 text-sm text-[var(--muted-ink)]">{p.highlights.slice(0, 2).join(" · ")}</p>
                </div>
                <ArrowUpRight className="h-6 w-6 shrink-0 text-[var(--muted-ink)] transition-transform group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[var(--rust)]" />
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
